<template>
  <div class="requirements dbox" v-if="selectedArtistData && selectedArtistData.travel_options">
    <TextField2
      :id="'default_performance_time_contract'"
      :label="$dft.capHead($t('playtime'))"
      :value="selectedArtist.default_performance_time_contract"
      :placeholder="$t('playtime')"
      @change="onTextFieldValueChange"
    />

    <TextField2
      :id="'default_setup_time'"
      :label="$dft.capHead($t('setup_time'))"
      :value="selectedArtist.default_setup_time"
      :placeholder="$t('setup_time')"
      @change="onTextFieldValueChange"
    />
    <TextField2
      :id="'signature_url'"
      :label="$dft.capHead($t('signature_url'))"
      :value="selectedArtist.signature_url"
      :placeholder="$t('signature_url')"
      @change="onTextFieldValueChange"
    />
    <TextField2
      :id="'tripit_ical'"
      :label="$dft.capHead($t('tripit'))"
      :value="selectedArtist.tripit_ical"
      :placeholder="$t('tripit')"
      @change="onTextFieldValueChange"
    />
    <TextField2
      :id="'techrider_url'"
      :label="$dft.capHead($t('techrider_url'))"
      :value="selectedArtist.techrider_url"
      :placeholder="$t('techrider_url')"
      @change="onTextFieldValueChange"
    />
    <TextField2
      :id="'default_travel_qty'"
      :label="$dft.capHead($t('travel_qty'))"
      :value="selectedArtist.default_travel_qty"
      :placeholder="$t('travel_qty')"
      @change="onTextFieldValueChange"
    />
    <Dropdown2
      :options="travelOptions"
      :selected="
        travelOptions.find(e => e.value == selectedArtist.travel_options)
      "
      :label="$dft.capHead($t('travel_options'))"
      :placeholder="$t('travel_options')"
      v-on:selectedChange="e => onDropdownChange('travel_options', e)"
      :listHeight="150"
    >
    </Dropdown2>
    <Dropdown2
      :options="travelOptions"
      :selected="
        travelOptions.find(
          e => e.value == selectedArtist.default_travel_option2
        )
      "
      :label="$dft.capHead($t('snd_travel_option'))"
      :placeholder="$t('snd_travel_option')"
      v-on:selectedChange="e => onDropdownChange('default_travel_option2', e)"
      :listHeight="150"
    >
    </Dropdown2>
    <TextField2
      :id="'default_guestlist_tickets'"
      :label="$dft.capHead($t('guestlist_tickets'))"
      :value="selectedArtist.default_guestlist_tickets"
      :placeholder="$t('guestlist_tickets')"
      @change="onTextFieldValueChange"
    />

    <TextField2
      :id="'default_feedback'"
      :label="$dft.capHead($t('artist_feedback'))"
      :value="selectedArtist.default_feedback"
      textarea
      :height="115"
      :placeholder="$t('artist_feedback')"
      @change="onTextFieldValueChange"
      bb="0px"
    />
  </div>
</template>

<script>
import TextField from "@plugins/text-field/text-field";
import Dropdown from "@plugins/dropdown/dropdown";
import { ArtistService } from "../../../services/artists";
import { EventHooks } from "../../../../../plugins/text-field";

export default {
  components: {
    TextField,
    Dropdown
  },
  props: {
    selectedArtist: {
      type: Object,
      required: true
    },
    selectedArtistData: {
      type: Object,
      required: true
    }
  },
  data: function() {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,

        validationEvent: EventHooks.OnBlur,
        changeEvent: EventHooks.OnBlur
      },
      notes: "",
      countries: [],
      selectedCountry: null
      // Mark: Data
    };
  },
  mounted: function() {},
  watch: {},
  computed: {
    travelOptions: function() {
      return this.selectedArtistData.travel_options.map(e => ({
        text: e.travel_option_text,
        value: e.travel_option_text
      }));
    }
  },
  methods: {
    onTextFieldValueChange: function({ name, value }) {
      console.log(name, value);
      this.$emit("changed", { name, value });
    },
    onDropdownChange: function(name, value) {
      console.log(name, value);
      this.$emit("changed", { name, value: value.value });
    }
    // Mark: Methods
  }
};
</script>

<style lang="scss" scoped>
// .dt-input-box--container {
//   margin: 5px;
// }
</style>
